__webpack_require__.p = "/evaluator-handicap/";